

export class SmsAllocationStatusInput implements ISmsAllocationStatusInput {
    /** The auto-generated id of the sms allocation master */
    smsAllocationId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ISmsAllocationStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.smsAllocationId = _data["smsAllocationId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): SmsAllocationStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new SmsAllocationStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["smsAllocationId"] = this.smsAllocationId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ISmsAllocationStatusInput {
    /** The auto-generated id of the sms allocation master */
    smsAllocationId: number;
    /** The updated status */
    status: number;
}

